import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'bd-link-internal',
    template: `
    <a
      [routerLink]="link()"
      [attr.aria-label]="label() ?? null"
      [attr.title]="label() ?? null"
    >
        <ng-content>
        </ng-content>
    </a>
  `,
    styles: [`

  `],
    imports: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdLinkInternalComponent {
    link = input<string[]>([]);
    /** Accessible name for the link; without it, icon-only content leaks
     * its ligature text (e.g. "open_in_new") as the announced name. */
    label = input<string | undefined>(undefined);
}
